import { EnergieEnum } from '../../../pages/rt2012/suivi-des-consommations/enums/EnergieEnum';
import { AbstractConsommationEnergie } from './abstract-consommation-energie';
import {
  getGrapheTypeEnumName,
  GrapheTypeEnum
} from '../../../pages/rt2012/suivi-des-consommations/enums/GrapheTypeEnum';

export class ConsommationEnergieByYear extends AbstractConsommationEnergie {

  public distribute(selectedEnergie: EnergieEnum): any {
    const consommations = {};

    for (const consommation of this.consommations) {
      const date = new Date(consommation.date);

      if (this.checkDate(date)) {
        if (typeof consommations[date.getFullYear()] === 'undefined') {
          consommations[date.getFullYear()] = [];
        }
        if (selectedEnergie === consommation.energie) {
          consommations[date.getFullYear()].push({
            name: consommation.energie,
            value: consommation.value
          });
        }
      }
    }

    return Object.keys(consommations)
      .sort((a, b) => parseInt(a, 0) > parseInt(b, 0) ? 1 : -1)
      .map(year => ({
        name: getGrapheTypeEnumName(this.locale, GrapheTypeEnum.ANNEE, new Date(parseInt(year, 0), 1)),
        series: [].concat(consommations[year])
      })).flat();
  }

  private checkDate(date: Date): boolean {
    return date.getFullYear() >= this.fromDate.getFullYear()
      && date.getFullYear() <= this.toDate.getFullYear();
  }
}
